import type {
  HirerInfo,
  HirerInfoAction,
  ActionType,
} from 'src/app/v1/state/types/hirerInfo';

const defaultState: HirerInfo = {
  firstName: undefined,
  lastName: undefined,
  emailAddress: undefined,
};

const RESET = 'tealium/hirerInfo/RESET' as ActionType.RESET;
const UPDATE = 'tealium/hirerInfo/UPDATE' as ActionType.UPDATE;

export const actionResetHirerInfo = () => ({
  type: RESET,
});

export const actionUpdateHirerInfo = (value: HirerInfo) => ({
  type: UPDATE,
  value,
});

export default (state: HirerInfo = defaultState, action: HirerInfoAction) => {
  switch (action.type) {
    case RESET: {
      return defaultState;
    }
    case UPDATE: {
      return action.value;
    }
    default: {
      return state;
    }
  }
};

export const forTest = {
  defaultState,
  RESET,
  UPDATE,
};
